import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { DraggableModalDndContext } from './contexts/DndContext'
import { DraggableModalStoreContext } from './contexts/StoreContext'
import { createDraggableModalStore } from './store'
import { DraggableModalStoreUpdater } from './StoreUpdater'

export const DraggableModalStoreProvider = ({
  children
}: PropsWithChildren) => {
  const store = useCreation(() => createDraggableModalStore(), [])

  return (
    <DraggableModalStoreContext value={store}>
      <DraggableModalDndContext>
        <DraggableModalStoreUpdater />
        {children}
      </DraggableModalDndContext>
    </DraggableModalStoreContext>
  )
}
